import AccountSettings from '@/mixins/accountSettings.mixin';
import { Component, Mixins } from 'vue-property-decorator';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
@Component
export class EmailInviteSent extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {

  onClick() {
    this.$gtm && this.$gtm.trackEvent({
      event: null,
      category: 'Email Sent',
      action: 'click',
      label: 'Email Sent Click Event Activated',
      value: 5000,
      noninteraction: false,
    });
  }

  mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }
  }
}